var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',[_c('div',{staticClass:"btn dealers_btn mr-3",on:{"click":function($event){return _vm.showDetails()}}},[_vm._v("\n        "+_vm._s(_vm.$t('text.clickButtons.details'))+"\n        ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }